<template>
  <div class="company-switcher__footer">
    <button
      type="button"
      class="company-switcher__create"
      @click="$emit('create')"
    >
      <lucide-icon
        :icon="icons.plus"
        :size="16"
        aria-hidden="true"
        class="company-switcher__create-icon"
      />
      {{ $t('criarnovaempresa') }}
    </button>
  </div>
</template>

<script>
import { Plus } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'CompanySwitcherCreateButton',
  components: { LucideIcon },
  computed: {
    icons() {
      return { plus: Plus }
    }
  }
}
</script>
